<template>
  <div>
    <div style="margin: 5px">
      <label class="d-flex">
        {{ $t('settings.clientProp.propertyName') }}

      </label>
      <BFormInput
        v-model="name"
        :placeholder="$t('settings.clientProp.propertyName')"
        size="sm"
      />
    </div>

    <BoxSelect
      v-if="!field"
      :selected.sync="type"
      :fields="fieldTypes"
      class="mt-2"
    />
    <div
      v-else
      class="d-flex align-items-center field-type"
    >
      <i
        :class="selectedFieldType.icon"
        class="mr-2"
      />
      <div>
        {{ selectedFieldType.text }}
      </div>
    </div>

    <div class="d-flex align-items-center mt-2 px-3">
      <BFormCheckbox
        switch
        class="white-switch white-switch-sm"
        :disabled="pending"
        :checked="highlight"
        @change="highlight = !highlight"
      />
      <span
        class="small"
        style="line-height: 1.1;"
      >
        Wyróżnij
      </span>
    </div>
  </div>
</template>

<script>
import BoxSelect from '@/components/BoxSelect';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    field: Object,
    pending: Boolean,
    catalogId: String,
  },
  data: () => ({
    name: '',
    type: 'Text',
    highlight: false,
  }),
  components: {
    BoxSelect,
  },
  computed: {
    ...mapGetters('shop', ['fieldTypes']),
    selectedFieldType() {
      return this.fieldTypes.find((x) => x.key === this.type);
    },
    metadata() {
      return {
        highlight: this.highlight,
      };
    },
  },
  watch: {
    name() {
      this.validate();
    },
  },
  methods: {
    ...mapActions('shop', [
      'createShopListingField',
      'updateShopListingField',
      'deleteShopListingField',
      'updateShopListingFieldsOrder',
    ]),
    validate() {
      if ((this.name || '').length === 0) {
        this.$emit('valid', false);
        return;
      }

      this.$emit('valid', true);
    },
    submit() {
      if (this.field) {
        this.update();
      } else {
        this.add();
      }
    },
    update() {
      this.$emit('update:pending', true);
      this.updateShopListingField({
        params: {
          fieldId: this.field.fieldId,
          catalogId: this.catalogId,
        },
        data: {
          name: this.name,
          metadata: JSON.stringify(this.metadata),
        },
      })
        .then(() => {
          this.name = '';
          this.$emit('update:pending', false);
          this.$emit('close');
        })
        .catch(() => {
          this.$emit('update:pending', false);
        });
    },
    add() {
      this.$emit('update:pending', true);
      this.createShopListingField({
        params: {
          catalogId: this.catalogId,
        },
        data: {
          name: this.name,
          type: this.type,
          metadata: JSON.stringify(this.metadata),
        },
      })
        .then(() => {
          this.name = '';
          this.$emit('update:pending', false);
          this.$emit('close');
        })
        .catch(() => {
          this.$emit('update:pending', false);
        });
    },
    remove() {
      this.$emit('update:pending', true);
      this.deleteShopListingField({
        params: {
          catalogId: this.catalogId,
          fieldId: this.field.fieldId,
        },
      })
        .then(() => {
          this.$emit('update:pending', false);
          this.$emit('close');
        })
        .catch(() => {
          this.$emit('update:pending', false);
        });
    },
  },
  created() {
    if (this.field) {
      this.name = this.field.name;
      this.type = this.field.type;
      if (this.field.metadata) {
        try {
          this.highlight = JSON.parse(this.field.metadata).highlight;
        } catch {
          // unable to parse metadata
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .warning {
    background-color: rgba($red, 0.2);
    padding: 10px 20px;
    border-radius: 20px;
  }

  .rule-edit {
    font-size: 0.7rem;
  }

  .selected-bank-account {
    border: 1px solid #eee;
    border-radius: 5px;
    padding: 5px;
  }

  .field-type {
    border: 1px solid #eee;
    color: #666;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.1;
    margin: 5px;
    padding: 8px;
    border-radius: 10px;
    transition: background-color 300ms, border-color 300ms;

    i {
      font-size: 20px;
      padding-bottom: 5px;
    }

    &.selected {
      border-color: $darkblue;
      background-color: rgba($blue, 0.1);
      color: $darkblue;
    }
  }
</style>
